import { selectChangeMessageForPreviousVersionItems } from '@UI/aside/asidePreviousVersionItems/AsidePreviousVersionItemsSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectGoalSubItem } from '@newStore/documentUI/transformContent/llinkidSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const LLINKID_EXTRA_GOAL_INFORMATION: BuildingBlockNodeConfig = {
  nodeSelector: selectGoalSubItem,
  information: {
    single: 'Extra',
    plural: "Extra's",
  },

  buildingBlocks: [],
  edit: [
    llinkidDescriptionComponent,
    {
      component: 'previousVersionItems',
      reactComponent: 'AsidePreviousVersionItems',
      label: 'Vervangt (uit vorige versie)',
      options: {
        relationTypes: ['REPLACES'],
        modal: 'llinkidPreviousVersionModal',
        modalTitle: 'Vervangt (uit vorige versie)',
        listColumn: 'description',
        placeholder: 'Kies een te vervangen extra',
        relation: 'Extra',
        errorMessage: 'Je moet een geldige extra selecteren',
        type: ContentType.LLINKID_EXTRA_GOAL_INFORMATION,
      },
      asideChangeMessageSelector: selectChangeMessageForPreviousVersionItems,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINKID_EXTRA_GOAL_INFORMATION;
